<div class="messageBoxContainer">
    <div class="messageBoxText">
        <div [innerHTML]="messageBoxText"></div>
    </div>
</div>
